import { render, staticRenderFns } from "./OrgCapacityHealthOverview.vue?vue&type=template&id=3bca5efa&scoped=true"
import script from "./OrgCapacityHealthOverview.vue?vue&type=script&lang=js"
export * from "./OrgCapacityHealthOverview.vue?vue&type=script&lang=js"
import style0 from "./OrgCapacityHealthOverview.vue?vue&type=style&index=0&id=3bca5efa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bca5efa",
  null
  
)

export default component.exports